import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const Wrapper = styled.div`
  text-align: center;
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 15px;
`;

export const IconWrapper = styled.a`
  display: block;
  background: ${(props) => props.theme.color.blue.default};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  width: 64px;
  height: 64px;
  &:not(:last-child) {
    margin-right: 25px;
  }
`;

export const Icon = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  ${mediaQuery('desktop')} {
    display: none;
  }
`;

export const Image = styled.img`
  object-fit: contain;
  object-position: center bottom;
  &:not(:last-child) {
    margin-right: 25px;
  }
`;
